module.exports = __webpack_public_path__ + "static/img/douyinhao.2c2913c1.png";